import React from 'react'
import { isTablet } from 'react-device-detect'
import PropTypes from 'prop-types'

import { Contact, Dots, FlyingCube, Heading } from 'Components/Blocks/_Legacy'
import { Motion, Wrapper } from 'Components/UI'

import { DATA_LAYERS } from 'Constants/DataLayers'

import { addDataLayer } from 'Services/gtm'

import { Container, Content, DotsWrapper } from './styles'

function LetsTalk({ data }) {
  const handleSent = () => {
    addDataLayer(DATA_LAYERS.blockchain.sendRequest)
  }

  return (
    <Container>
      <Wrapper wayPointTop>
        <Content>
          <Motion>
            <Heading
              mb={11}
              subTitleText={data.subtitleText}
              titleText={{
                first: {
                  text: data.titleTextFirst,
                  bold: data.firstBold,
                },
                second: {
                  text: data.titleTextSecond,
                  bold: data.secondBold,
                },
              }}
            />

            <Contact onSent={handleSent} />
          </Motion>

          <FlyingCube
            right={[0, 0, 35, 35, 35, 35, -100]}
            rotateAngle={isTablet ? 38 : 20}
            size={[0, 0, 150, 150, 150, 150, 210]}
            top={[0, 0, -35, -35, -35, -35, 64]}
          />
        </Content>

        <DotsWrapper>
          <Dots columns={22} primary rows={15} />
        </DotsWrapper>
      </Wrapper>
    </Container>
  )
}

LetsTalk.defaultProps = {
  data: {},
}

LetsTalk.propTypes = {
  data: PropTypes.object,
}

export default LetsTalk
